// G6-0: the effective costing method of an item. Lot-tracked items are relieved FIFO (or FEFO) by lot;
// every other stock item is relieved at the moving average per store x item.

export type CostingMethod = 'FIFO_LOT' | 'MOVING_AVERAGE';

export function costingMethodOf(item?: { costingMethod?: CostingMethod | null; lotTracked?: boolean | null } | null): CostingMethod {
    if (item?.costingMethod) return item.costingMethod;
    return item?.lotTracked ? 'FIFO_LOT' : 'MOVING_AVERAGE';
}

/** "Costing: FIFO by lot" / "Costing: Moving average". */
export function costingMethodLabel(item?: { costingMethod?: CostingMethod | null; lotTracked?: boolean | null } | null): string {
    return costingMethodOf(item) === 'FIFO_LOT' ? 'Costing: FIFO by lot' : 'Costing: Moving average';
}
